// Import scss so webpack will bundle it and export with ExtractTextPlugin
import '../scss/global.scss';

// import site methods
import './methods/sliders';
import './methods/analytics';
import observer from './methods/lozad';

observer.observe();

// polyfills
// IntersectionObserver polyfill
// for Lozad.js
// https://www.npmjs.com/package/intersection-observer
require('intersection-observer');



// WEBPACK FOOTER //
// ./src/js/main.js